<div class="with-auth">
  <app-internet-status-banner></app-internet-status-banner>
  <app-user-update-notification></app-user-update-notification>
  <app-top-bar></app-top-bar>
  <app-left-side-bar></app-left-side-bar>
  <app-right-side-bar [draggable]="dialpadService.isDraggable"
    [isCompact]="dialpadService.isCompact"></app-right-side-bar>
  <notifications></notifications>
  <requests></requests>
  <bug-report></bug-report>
  <app-on-going-call></app-on-going-call>
  <app-audio-visualizer></app-audio-visualizer>
  <app-incoming-call></app-incoming-call>
  <flecx-modal></flecx-modal>
  <app-pge-customer-search-modal></app-pge-customer-search-modal>
  <app-lead-preview-modal></app-lead-preview-modal>
  <app-campaign-update-modal></app-campaign-update-modal>
  <app-priority-update-modal></app-priority-update-modal>
  <app-bulk-campaign-update-modal></app-bulk-campaign-update-modal>
  <app-update-team-structure-modal></app-update-team-structure-modal>
  <app-leads-assigned-modal></app-leads-assigned-modal>
  <app-timezone-clock-modal></app-timezone-clock-modal>
  <app-clone-user-modal></app-clone-user-modal>
  <main>
    <div class="section-wrapper"
      [ngClass]="{'no-bottom-pad': !campaignService.isCallConnected.value, 'chat-section-wrapper' : true}">
      <!-- <ng-scrollbar style="height: calc(100vh - 94px); margin-top: 2px; z-index: 32;" visibility="hover"> -->
      <app-center-selection></app-center-selection>
      <router-outlet></router-outlet>
      <!-- </ng-scrollbar> -->
    </div>
  </main>
</div>